import { useState } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

function Lightbox({ children, src, type = 'image', alt = '' }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Box
        onClick={() => setOpen(true)}
        sx={{
          cursor: 'zoom-in',
          '&:hover': {
            opacity: 0.9
          }
        }}
      >
        {children}
      </Box>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Box
          onClick={() => setOpen(false)}
          sx={{
            position: 'relative',
            outline: 'none',
            maxWidth: '95vw',
            maxHeight: '95vh'
          }}
        >
          {/* Close button */}
          <Box
            sx={{
              position: 'absolute',
              top: -40,
              right: 0,
              width: 36,
              height: 36,
              borderRadius: '50%',
              backgroundColor: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
              zIndex: 10,
              '&:hover': {
                transform: 'scale(1.1)'
              }
            }}
          >
            ✕
          </Box>

          {type === 'image' ? (
            <img
              src={src}
              alt={alt}
              style={{
                maxWidth: '95vw',
                maxHeight: '90vh',
                objectFit: 'contain',
                borderRadius: '8px'
              }}
            />
          ) : (
            <video
              src={src}
              autoPlay
              loop
              muted
              playsInline
              controls
              style={{
                maxWidth: '95vw',
                maxHeight: '90vh',
                objectFit: 'contain',
                borderRadius: '8px'
              }}
            />
          )}
        </Box>
      </Modal>
    </>
  );
}

export default Lightbox;
